import LoginFormModal from './LoginFormModal';

export default LoginFormModal;


// WEBPACK FOOTER //
// ./src/components/LoginFormModal/index.jsx